module.exports = __webpack_public_path__ + "img/exmo.d6cb3af6.svg";